import { type VehicleSearchProps } from '@allesauto/core/vehicleSearch';
import { getPcpUrl } from '@allesauto/utils/routeUtils';
import debounce from 'lodash/debounce';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

type OnChange = Exclude<VehicleSearchProps['onChange'], undefined>;

export const useOnChange = () => {
  const router = useRouter();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback<OnChange>(
    debounce(({ isDefaultPriceRange, priceRange, make, modelGroup, model }) => {
      const url = getPcpUrl(
        isDefaultPriceRange,
        priceRange,
        make,
        modelGroup,
        model
      );

      router.prefetch(url.toString()); // works only in PRODUCTION builds
    }, 100),
    [router]
  );
};
